import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Spinner } from "@telegram-apps/telegram-ui";
import { api } from "../../lib/api.js";
import { usePageBack } from "../../lib/telegram.js";

export default function AirfieldsList() {
  const navigate = useNavigate();
  usePageBack("/superadmin");
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [name, setName] = useState("");
  const [slug, setSlug] = useState("");
  const [creating, setCreating] = useState(false);

  function reload() {
    setData(null);
    api("/api/v1/superadmin/airfields").then(setData).catch((e) => setError(e.message));
  }
  useEffect(reload, []);

  async function createField(e) {
    e?.preventDefault?.();
    if (!name.trim() || !slug.trim()) {
      setError("Имя и slug обязательны.");
      return;
    }
    setCreating(true);
    setError(null);
    try {
      const r = await api("/api/v1/superadmin/airfields", {
        method: "POST",
        body: JSON.stringify({ name: name.trim(), slug: slug.trim() }),
      });
      setName(""); setSlug("");
      navigate(`/superadmin/airfields/${r.airfield.slug}`);
    } catch (e2) {
      setError(e2.message);
    } finally {
      setCreating(false);
    }
  }

  return (
    <>
      <section className="portal-card">
        <header className="portal-card__header">
          <h2 className="portal-card__title">Новый аэродром</h2>
        </header>
        <form onSubmit={createField} style={{ display: "grid", gap: 10, gridTemplateColumns: "1fr 1fr auto" }}>
          <PortalInput placeholder="Например: РКА Тушино" value={name} onChange={setName} aria-label="Название" />
          <PortalInput placeholder="tushino (a-z, 0-9, -)" value={slug} onChange={(v) => setSlug(v.toLowerCase())} aria-label="Slug" />
          <button type="submit" className="portal-pager__btn" disabled={creating} style={{ background: "var(--portal-text)", color: "#fff", borderColor: "var(--portal-text)" }}>
            {creating ? "Создаём…" : "Создать"}
          </button>
        </form>
        {error && <p className="portal-empty" style={{ color: "var(--portal-danger)", marginTop: 10 }}>{error}</p>}
      </section>

      <section className="portal-card portal-card--flush">
        <header className="portal-card__header">
          <h2 className="portal-card__title">{data ? `Аэродромов: ${data.airfields.length}` : "Загрузка…"}</h2>
        </header>
        {!data && !error && <div style={{ padding: 24, display: "flex", justifyContent: "center" }}><Spinner size="m" /></div>}
        {data?.airfields?.length === 0 && <p className="portal-empty" style={{ padding: "0 22px 18px" }}>Аэродромов нет.</p>}
        {data?.airfields?.length > 0 && (
          <div className="portal-list" style={{ border: 0, borderRadius: 0, boxShadow: "none" }}>
            {data.airfields.map((a) => (
              <button
                key={a.slug}
                type="button"
                className="portal-list__row"
                onClick={() => navigate(`/superadmin/airfields/${a.slug}`)}
              >
                <div className="portal-list__avatar">🛫</div>
                <div className="portal-list__body">
                  <div className="portal-list__title">{a.name}</div>
                  <div className="portal-list__sub">
                    {a.slug} · {a.member_count} участн. · {a.admin_count} админ.
                  </div>
                </div>
                <div className="portal-list__after">→</div>
              </button>
            ))}
          </div>
        )}
      </section>
    </>
  );
}

function PortalInput({ value, onChange, ...rest }) {
  return (
    <input
      {...rest}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      style={{
        font: "inherit", fontSize: 14, padding: "10px 14px",
        background: "var(--portal-surface)", color: "var(--portal-text)",
        border: "1px solid var(--portal-border)", borderRadius: 10, outline: "none",
      }}
    />
  );
}
